import { CORE_TEXT, createLocaleTextHook } from '@moonpig/web-core-locale-text'

export const VARIANT_SELECTOR_MODULE_TEXT = {
  'common.flower_variant_description_standard': {
    'en-GB': 'To show them you care',
    'nl-NL': 'Laat zien dat je om hen geeft',
  },
  'common.flower_variant_description_large': {
    'en-GB': 'Moonpig favourite',
    'nl-NL': 'Favoriet op Greetz',
  },
  'common.select_size': {
    'en-GB': 'Select Size',
    'nl-NL': 'Kies het formaat',
  },
  'common.what_size': { 'en-GB': 'What Size?', 'nl-NL': 'Welk formaat?' },
  'common.select_bouquet_size': {
    'en-GB': 'Select bouquet size',
    'nl-NL': 'Selecteer formaat boeket',
  },
}

export type VariantSelectorModuleDictionary =
  | keyof typeof CORE_TEXT
  | keyof typeof VARIANT_SELECTOR_MODULE_TEXT

export const useVariantSelectorModuleLocaleText = createLocaleTextHook({
  dictionary: {
    ...CORE_TEXT,
    ...VARIANT_SELECTOR_MODULE_TEXT,
  },
})
